import request from './../utils/request'


export function index(params) {
    return request({
        url: '/partner-clinic-report',
        method: 'get',
        params
    })
}



export function show(params) {
    return request({
      url: `/partner-clinic-report/${params.id}`,
      method: 'get',
      params
    })
  }


